import { cn } from '@/lib/utils';

type AttendanceStatus = 'present' | 'late' | 'absent';

const statusStyles: Record<AttendanceStatus, { bg: string; text: string; label: string }> = {
  present: { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-700 dark:text-green-400', label: 'Present' },
  late: { bg: 'bg-yellow-100 dark:bg-yellow-900/30', text: 'text-yellow-700 dark:text-yellow-400', label: 'Late' },
  absent: { bg: 'bg-red-100 dark:bg-red-900/30', text: 'text-red-700 dark:text-red-400', label: 'Absent' },
};

interface StatusBadgeProps {
  status: AttendanceStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const style = statusStyles[status];
  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', style.bg, style.text, className)}>
      {style.label}
    </span>
  );
}

/** Color class for attendance percentage values */
export function getAttendanceColor(percent: number): string {
  if (percent >= 80) return 'text-green-600';
  if (percent >= 50) return 'text-yellow-600';
  return 'text-red-600';
}

/** Badge class for attendance percentage values */
export function getAttendanceBadge(percent: number): string {
  if (percent >= 80) return 'bg-green-100 text-green-700';
  if (percent >= 50) return 'bg-yellow-100 text-yellow-700';
  return 'bg-red-100 text-red-700';
}
